(($, Drupal) => {
  const initMediaWithTextModal = (el) => {
    const $toggler = $(el);
    const $closeBtn = $toggler.parents('.container').find('.mwt-modal__close');
    const $target = $toggler.parents('.container').find('.mwt-modal').detach();

    const $overlay = $('<div />', {
      class: ['overlay', 'overlay--modal'].join(' '),
    });

    if ($toggler.length === 0 || $target.length === 0) {
      return;
    }

    function closeModal() {
      $target.fadeOut(50, () => $target.remove);
      $overlay.removeClass('is-open');
      $toggler.attr('aria-pressed', false);

      $overlay.off('click', closeModal);
      $closeBtn.off('click', closeModal);

      $overlay.remove();
    }

    function handleUsingEscKey(e) {
      const key = e.key || e.keyCode;
      if (key === 27 || key === 'Escape') {
        closeModal();
      }
    }

    $toggler.on('click keypress', () => {
      $('body').append($overlay);
      $('body').append($target);
      const scrollTop = $(document).scrollTop();
      $target.css({ top: `${scrollTop}px` });
      $target.fadeIn(50);
      $overlay.addClass('is-open');

      $overlay.on('click', closeModal);

      $(document).on('keydown', (e) => {
        handleUsingEscKey(e);
      });

      $closeBtn.on('click', closeModal);
    });
  };

  Drupal.behaviors.mstMediaWithTextModal = {
    attach: (context) => {
      $('.media-with-text__modal-toggle', context).each((index, element) => initMediaWithTextModal(element));
    },
  };
})(jQuery, Drupal);
